const $courseList = $('.course-list');

if ($courseList.length > 0) {
  setSpanSize();

  $(window).on('resize load', function () {
    setSpanSize();
  });
}

function setSpanSize () {
  const $courseItem = $courseList.children('li');
  $courseItem.each(function (key, item) {
    const $image = $(item).find('img');
    const imageHeight = $image.height();

    const $span = $(item).find('figcaption').children('span');

    $span.css({
      width: imageHeight,
    });
  });
}